"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconDocumentFilled = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    viewBox: "0 0 16 20",
    ...props,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M0.01,0 L0,20 L16,20 L16,6 L10,0 L0.01,0 Z M9,7 L9,1.5 L14.5,7 L9,7 Z",
        id: "path-1-icon-document-filled"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        transform: "translate(-344.000000, -1431.000000)",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          transform: "translate(344.000000, 1431.000000)",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("mask", {
            id: "mask-2-icon-document-filled",
            fill: "white",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
              xlinkHref: "#path-1-icon-document-filled"
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("use", {
            fill: "#000000",
            fillRule: "nonzero",
            xlinkHref: "#path-1-icon-document-filled"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            mask: "url(#mask-2-icon-document-filled)",
            fill: "#000000",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              transform: "translate(-4.000000, -2.000000)",
              id: "Rectangle",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                x: "0",
                y: "0",
                width: "24",
                height: "24"
              })
            })
          })]
        })
      })
    })]
  });
};
var _default = exports.default = (0, _withIcon.default)('IconDocumentFilled')(IconDocumentFilled);